"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLocal = void 0;
var isLocal = function () {
    var hostName = window.location.hostname.split('.')[0];
    return hostName === 'localhost';
};
exports.isLocal = isLocal;
